import React from 'react'

import { LntSelect } from '@app/components/base'
import { TopFilters as TopFiltersWrapper } from '@app/components'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { CONTRACTORS_KEY, LOCATION_KEY, MONITORINGS_TYPES_KEY } from '@app/constants/queryKeys'

import { getTypes } from '@app/api/routes/monitorings'
import { getContractors } from '@app/api/routes/contractors'
import { getClusters } from '@app/api/routes/locationСlusters'

import { useFiltersSearch } from '@app/hooks'

import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { commonSelectProps } from './configs'

import type { TopFilterProps } from './types'

export const TopFilters: React.FC<TopFilterProps> = ({ onSearch, initialFilters }) => {
  const { filters, canResetFilters, handleClearFilters, handleSearch, handleSelectFilterChange } = useFiltersSearch({
    initialFilters,
    onSearch
  })

  return (
    <TopFiltersWrapper
      canReset={ canResetFilters }
      onClear={ handleClearFilters }
      onSearch={ handleSearch }
    >
      <LntSelect
        { ...commonSelectProps }
        value={ filters.monitoringTypeIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.monitoringTypeIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.monitoringsTypeFilter }
        querySelect={ {
          queryKey: [MONITORINGS_TYPES_KEY.typesItems],
          queryFn: getTypes,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.clusterIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.clusterIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClustersItems],
          queryFn: getClusters,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.contractorIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.contractorIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.contractorsFilter }
        querySelect={ {
          queryKey: [CONTRACTORS_KEY.contractorsItems],
          queryFn: getContractors,
          select: getFilterFromEntities
        } }
      />
    </TopFiltersWrapper>
  )
}
